/**
 * The hover box every reference-range bar in the app shows: this draw over
 * the one it is being compared with.
 *
 * ONE DEFINITION FOR ALL OF THEM. It used to be the same template literal
 * copy-pasted into five charts, which is how they came to disagree: the MVX
 * bars had no box at all until 2026-10-15, and the dates went in by hand.
 *
 * THE DATES ARE THE POINT. A practitioner can compare any two tests, not just
 * consecutive ones, so "Previous" on its own does not say which draw
 * (Maryann, 2026-10-15). They are NOT bold: the label and the result are what
 * the eye needs first, and a bold date competes with the number beside it.
 */
export function currentPreviousTooltip(
  current: string,
  previous: string,
  currentDate?: string,
  previousDate?: string,
): string {
  const on = (d?: string) => (d ? `<span style="font-weight:400"> (${d})</span>` : '');
  return (
    ` <b>Current</b>${on(currentDate)}<b>: ${current}</b>` +
    `<br><b>Previous</b>${on(previousDate)}<b>: ${previous}</b>`
  );
}
